import { useContext } from "react";
import { SidebarControllerContext } from "@/contexts/SidebarControllerContext";

export const useSidebarController = () => useContext(SidebarControllerContext);
